// Three-dot "thinking…" placeholder shown while we wait for the
// agent's reply to arrive. Visual structure mirrors ChatMessageBubble
// so the layout doesn't jump when the real bubble lands.
type Props = {
  label?: string
  /** Side the indicator sits on. Defaults to left ("they're typing back"). */
  side?: "left" | "right"
}

export function ChatThinkingIndicator({ label = "Agent", side: _side }: Props) {
  void _side
  const Avatar = (
    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-vip-gold/40 bg-vip-goldMute text-vip-goldSoft">
      <span className="text-xs">…</span>
    </div>
  )
  return (
    <div className="flex w-full gap-3">
      {Avatar}
      <div className="flex max-w-[640px] min-w-0 flex-col gap-1.5">
        <div className="flex items-baseline gap-2 text-[11px]">
          <span className="font-semibold text-app-text">{label}</span>
          <span className="text-app-subtle">thinking</span>
        </div>
        <div className="rounded-card border border-border bg-app-panel2 px-4 py-2.5">
          <div className="flex items-center gap-1">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-app-muted [animation-delay:0ms]" />
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-app-muted [animation-delay:200ms]" />
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-app-muted [animation-delay:400ms]" />
          </div>
        </div>
      </div>
    </div>
  )
}
